/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyZloty = createReactComponent("outline", "currency-zloty", "IconCurrencyZloty", [["path", { "d": "M12 18h-7l7 -7h-7", "key": "svg-0" }], ["path", { "d": "M17 18v-13", "key": "svg-1" }], ["path", { "d": "M14 14.5l6 -3.5", "key": "svg-2" }]]);

export { IconCurrencyZloty as default };
//# sourceMappingURL=IconCurrencyZloty.mjs.map
